/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Scope_PlanInputs */

const en_us2_swap_scope_plan = /** @type {(inputs: Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My plan, from now on`)
};

const pt_br2_swap_scope_plan = /** @type {(inputs: Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu plano, de agora em diante`)
};

const es_419_swap_scope_plan = /** @type {(inputs: Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi plan, de ahora en adelante`)
};

const pt_pt2_swap_scope_plan = /** @type {(inputs: Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O meu plano, a partir de agora`)
};

const fr_fr2_swap_scope_plan = /** @type {(inputs: Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon programme, désormais`)
};

const de_de2_swap_scope_plan = /** @type {(inputs: Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Plan, ab jetzt`)
};

const it_it2_swap_scope_plan = /** @type {(inputs: Swap_Scope_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mia scheda, da ora in poi`)
};

/**
* | output |
* | --- |
* | "My plan, from now on" |
*
* @param {Swap_Scope_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_scope_plan = /** @type {((inputs?: Swap_Scope_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Scope_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_scope_plan(inputs)
	if (locale === "es-419") return es_419_swap_scope_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_scope_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_scope_plan(inputs)
	if (locale === "de-DE") return de_de2_swap_scope_plan(inputs)
	if (locale === "it-IT") return it_it2_swap_scope_plan(inputs)
	return en_us2_swap_scope_plan(inputs)
});
export { swap_scope_plan as "swap.scope_plan" }